import { Action } from "@/src/data/types";
import { useEffect, useState } from "react";
import { getAllActions } from "../../../../API/Actions/actionService";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { ActionData } from "../../../../components/tables/actions-tables/action";

const breadcrumbItems = [
  { title: "Initiatives", link: "/admin-dashboard/initiative" },
];
export default function Actions() {
  const [actions, setActions] = useState<Action[]>([]);
  const fetchData = async () => {
    const response = await getAllActions();
    setActions(response?.actions);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <ActionData data={actions} />
        </div>
      </div>
    </>
  );
}
